import dayjs, { Dayjs } from "dayjs";

const yesterday = dayjs().subtract(1, "day");
export const disabledDateBeforeToday = (current: Dayjs) => {
  // Can not select days before today
  return current && current < yesterday.endOf("day");
};
